"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[513],{

/***/ 63820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  .disabled {\n    .page-link {\n      opacity: 0;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-0"
})(_templateObject());
var MobilePaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-1"
})(_templateObject1());
function NoticePagination(param) {
    var prev = param.prev, currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, next = param.next, pages = param.pages, nextEnd = param.nextEnd, prevStart = param.prevStart, handleActive = param.handleActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prevStart,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prev,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return handleActive(item);
                                    },
                                    className: currentPage == item ? "page-item active" : "page-item",
                                    style: {
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "page-link",
                                        children: item
                                    })
                                }, index);
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: next,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: nextEnd,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobilePaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage == 1)) {
                                        prev();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage == 1) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "page-item active",
                                style: {
                                    zIndex: 5
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: currentPage
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage >= pages)) {
                                        next();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage >= pages) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NoticePagination);


/***/ }),

/***/ 64728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30719);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64384);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  .swiper {\n    padding-bottom: 50px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(6, 1fr); /* \uAE30\uBCF8 6\uAC1C */\n  gap: 20px;\n\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(4, 1fr); /* \uD0DC\uBE14\uB9BF \uC138\uB85C / \uBAA8\uBC14\uC77C 2\uAC1C */\n    gap: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 28px;\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n\n  & figure {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    border-radius: 20px;\n    background-color: #f4f4f4;\n    padding: 8px;\n    border: ",
        ";\n\n    @media screen and (min-width: 1200px) {\n      width: 115px;\n      height: 115px;\n    }\n    @media screen and (max-width: 767px) {\n      min-width: 58px;\n      min-height: 58px;\n      max-width: 65px;\n      max-height: 65px;\n      border-radius: 15px;\n      padding: 0px;\n    }\n    @media screen and (max-width: 430px) {\n      width: 45px;\n      height: 45px;\n      border-radius: 15px;\n      padding: 0px;\n    }\n  }\n  & img {\n    width: 100%;\n  }\n  :hover {\n    & span {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  word-break: keep-all;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var serviceData = [
    {
        image: "/icons/main/main_icon_1.png",
        title: "\uCE7C\uB81B\uD2B9\uAC00",
        description: "\uC9C0\uAE08 \uAC00\uC7A5 \uD56B\uD55C \uAC00\uACA9",
        url: "/products/Caret-Special/"
    },
    {
        image: "/icons/main/main_icon_2.png",
        title: "\uB9DE\uCDA4\uC81C\uC791",
        description: "\uC6D0\uD558\uB294 \uB300\uB85C \uC81C\uC791\uAC00\uB2A5",
        url: "/customizing/customizing-products/"
    },
    {
        image: "/icons/main/main_icon_3.png",
        title: "\uC6A9\uB3C4\uBCC4 \uCD94\uCC9C",
        description: "\uC0C1\uD669\uC5D0 \uB531 \uB9DE\uB294 \uC0C1\uD488",
        url: "/products/Clothing-Packaging/"
    },
    {
        image: "/icons/main/main_icon_4.png",
        title: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C",
        description: "\uCE5C\uD658\uACBD \uD55C\uAC78\uC74C",
        url: "/products/Step-For-Net-Zero/"
    },
    {
        image: "/icons/main/main_icon_5.png",
        title: "\uC18C\uB7C9\uC778\uC1C4",
        description: "\uD544\uC694\uD55C \uB9CC\uD07C\uB9CC \uC778\uC1C4",
        url: "/customizing/print/"
    },
    {
        image: "/icons/main/main_icon_6.png",
        title: "\uACF5\uB3D9\uAD6C\uB9E4",
        description: "\uD568\uAED8, \uB354 \uC800\uB834\uD558\uAC8C",
        url: "/group-purchase/"
    },
    {
        image: "/icons/main/main_icon_7.png",
        title: "\uC2DC\uC81C\uD488\uC81C\uC791",
        description: "\uBE60\uB978 \uCD08\uAE30 \uC0D8\uD50C",
        url: "/customizing/prototype/"
    },
    {
        image: "/icons/main/main_icon_8.png",
        title: "\uD310\uCD09\uBB3C\uC81C\uC791",
        description: "\uBE0C\uB79C\uB4DC \uD64D\uBCF4\uC6A9",
        url: "/customizing/promotion/"
    }, 
];
// 카테고리 개별 구분
var CateogryMobileWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-0"
})(_templateObject());
var CategoryMobile = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-1"
})(_templateObject1());
var CategoryGrid = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-2"
})(_templateObject2());
var CategoryListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-3"
})(_templateObject3());
var CategoryList = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-4"
})(_templateObject4());
var CategoryBox = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a9cad90-5"
})(_templateObject5(), function(props) {
    return props.active ? "3px solid #3bb77e" : "none";
});
var CategorySliderName = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9a9cad90-6"
})(_templateObject6());
var CategorySlider = function(param) {
    var dummyList = param.dummyList, siteConfig = param.siteConfig;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("S"), categoryType = ref1[0], setCategoryType = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (!(dummyList === null || dummyList === void 0 ? void 0 : dummyList.category) || !router.isReady) return;
        // slug가 있거나 경로가 /products/[ename]인 경우 ename 추출
        var enameFromUrl = router.query.slug || ((ref = router.asPath.split("/products/")[1]) === null || ref === void 0 ? void 0 : ref.split("/")[0]);
        var matchedCategory = dummyList.category.find(function(cat) {
            return cat.ename === enameFromUrl;
        });
        if (matchedCategory && matchedCategory.division) {
            setCategoryType(matchedCategory.division);
            localStorage.setItem("categoryType", matchedCategory.division);
        }
    }, [
        router.isReady,
        router.query.slug,
        dummyList === null || dummyList === void 0 ? void 0 : dummyList.category
    ]);
    // 현재 선택된 카테고리 코드를 가져오는 함수
    var getCurrentCategoryCode = function() {
        if (router.query.code) {
            return router.query.code;
        }
        // URL이 /products/[slug] 형태인 경우 slug로 코드 찾기
        if (router.query.slug && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.category)) {
            var matchedCategory = dummyList.category.find(function(cat) {
                return cat.ename === router.query.slug;
            });
            if (matchedCategory) {
                return matchedCategory.code;
            }
        }
        return null;
    };
    // 현재 선택된 카테고리 코드
    var currentCategoryCode = getCurrentCategoryCode();
    // 공통으로 사용할 필터된 serviceData
    var filteredServiceData = serviceData.filter(function(item) {
        if (item.title === "\uC2DC\uC81C\uD488\uC81C\uC791" && (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Prototype) === null) {
            return false;
        }
        if (item.title === "\uD310\uCD09\uBB3C\uC81C\uC791" && (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion) === null) {
            return false;
        }
        return true;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !router.pathname.includes("products") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CateogryMobileWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoryMobile, {
                    children: new Array(Math.ceil(filteredServiceData.length / 8)).fill("").map(function(_, idx) {
                        return idx + 1;
                    }).map(function(el, gridIdx) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoryGrid, {
                                children: (ref = filteredServiceData.slice(el * 8 - 8, el * 8)) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CategoryBox, {
                                        onClick: function() {
                                            return router.push("".concat(item.url));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: item.image,
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategorySliderName, {
                                                    children: item.title
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        }, gridIdx);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoryListWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoryList, {
                    children: filteredServiceData === null || filteredServiceData === void 0 ? void 0 : filteredServiceData.map(function(item, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CategoryBox, {
                                onClick: function() {
                                    return router.push("".concat(item.url));
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: item.image,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategorySliderName, {
                                            children: item.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-xs",
                                        children: item.description
                                    })
                                ]
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(mapStateToProps, null)(CategorySlider));


/***/ }),

/***/ 43494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePaginationHandlerModified; }
/* harmony export */ });
/* unused harmony export usePaginationHandler */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var usePaginationHandler = function(param) {
    var products = param.products;
    var showPagination = 5;
    var showLimit = 20;
    var ref = useState(1), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = useState([]), pagination = ref1[0], setPagination = ref1[1];
    var ref2 = useState(1), pages = ref2[0], setPages = ref2[1];
    var ref3 = useState(showLimit), limit = ref3[0], setLimit = ref3[1];
    // 페이지네이션 생성
    var createPagination = function() {
        if (!products.items) return;
        var totalPages = Math.ceil(products.items.length / limit);
        var pageNumbers = new Array(totalPages).fill().map(function(_, idx) {
            return idx + 1;
        });
        setPagination(pageNumbers);
        setPages(totalPages);
        // 페이지 수가 변경되면 현재 페이지 범위 확인
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
        }
    };
    // 현재 페이지에 해당하는 제품 목록 계산
    var getPagedProducts = function() {
        if (!products.items || !products.items.length) return [];
        var startIdx = (currentPage - 1) * limit;
        var endIdx = startIdx + limit;
        return products.items.slice(startIdx, endIdx);
    };
    // 페이지네이션 컨트롤 함수
    var next = function() {
        if (currentPage < pages) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var prev1 = function() {
        if (currentPage > 1) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev - 1;
            });
        }
    };
    var handleActive = function(page) {
        window.scrollTo(0, 520);
        setCurrentPage(page);
    };
    var nextEnd = function() {
        window.scrollTo(0, 520);
        setCurrentPage(pages);
    };
    var prevStart = function() {
        window.scrollTo(0, 520);
        setCurrentPage(1);
    };
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        var groupStart = Math.floor((currentPage - 1) / showPagination) * showPagination;
        return pagination.slice(groupStart, groupStart + showPagination);
    };
    useEffect(function() {
        createPagination();
        setCurrentPage(1);
    }, [
        products.items
    ]);
    return {
        next: next,
        prev: prev1,
        handleActive: handleActive,
        nextEnd: nextEnd,
        prevStart: prevStart,
        getPagedProducts: getPagedProducts,
        getPaginationGroup: getPaginationGroup,
        createPagination: createPagination,
        currentPage: currentPage,
        pagination: pagination,
        pages: pages,
        limit: limit
    };
};
var usePaginationHandlerModified = function(param) {
    var products = param.products, _totalPages = param.totalPages, totalPages1 = _totalPages === void 0 ? 0 : _totalPages, _initialPage = param.initialPage, initialPage = _initialPage === void 0 ? 1 : _initialPage;
    var showPagination = 5;
    var showLimit = 20;
    var prevProductsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialPage), currentPage = ref[0], setCurrentPage = ref[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), pagination = ref4[0], setPagination = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(totalPages1 || 1), pages = ref5[0], setPages = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(showLimit), limit = ref6[0], setLimit = ref6[1];
    var resetPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var newPage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        setCurrentPage(newPage);
    }, []);
    // 페이지네이션 생성
    var createPagination = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!products) return;
        // 총 페이지 수 계산
        var totalPages;
        if (products.total_page) {
            // 서버에서 제공하는 총 페이지 수 사용
            totalPages = products.total_page;
        } else if (products.total_count) {
            // 총 항목 수로 계산
            totalPages = Math.ceil(products.total_count / limit);
        } else if (products.items && products.items.length) {
            // 아이템 배열 길이로 계산
            totalPages = Math.ceil(products.items.length / limit);
        } else if (products.data && products.data.length) {
            // 이미 페이지네이션된 데이터인 경우
            totalPages = Math.ceil(products.data.length / limit);
        } else {
            // 기본값
            totalPages = 1;
        }
        // 페이지 수가 변경된 경우에만 업데이트
        if (totalPages !== pages) {
            setPages(totalPages);
            // totalPages가 1일 경우 페이지네이션 업데이트를 하지 않음
            if (totalPages > 1) {
                var newPagination = Array.from({
                    length: totalPages
                }, function(_, i) {
                    return i + 1;
                });
                setPagination(newPagination);
            } else {
                setPagination([
                    1
                ]); // totalPages가 1일 경우 페이지네이션을 [1]로 설정
            }
        }
        // 이전 products 값 저장
        prevProductsRef.current = products;
    }, [
        products,
        limit,
        pages
    ]);
    // 현재 페이지에 해당하는 제품 목록 계산
    var getPagedProducts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (products.data) {
            return products.data;
        }
        // 클라이언트 사이드 페이지네이션 로직
        if (!products.items || !products.items.length) return [];
        var startIdx = (currentPage - 1) * limit;
        var endIdx = startIdx + limit;
        return products.items.slice(startIdx, endIdx);
    }, [
        currentPage,
        limit,
        products
    ]);
    // 페이지네이션 컨트롤 함수
    var next = function() {
        if (currentPage < pages) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var prev2 = function() {
        if (currentPage > 1) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev - 1;
            });
        }
    };
    var handleActive = function(page) {
        window.scrollTo(0, 520);
        setCurrentPage(page);
    };
    var nextEnd = function() {
        window.scrollTo(0, 520);
        setCurrentPage(pages);
    };
    var prevStart = function() {
        window.scrollTo(0, 520);
        setCurrentPage(1);
    };
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        // 현재 페이지가 중앙에 오도록 계산
        var start = Math.max(0, Math.min(pagination.length - showPagination, currentPage - Math.ceil(showPagination / 2)));
        var result = pagination.slice(start, start + showPagination);
        if (result.length === 1) return [];
        return result;
    };
    // products가 변경될 때마다 페이지네이션 재생성
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        createPagination();
    }, [
        products,
        createPagination
    ]);
    // initialPage가 변경되면 currentPage 동기화
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (initialPage !== currentPage) {
            setCurrentPage(initialPage);
        }
    }, [
        initialPage
    ]);
    return {
        next: next,
        prev: prev2,
        handleActive: handleActive,
        nextEnd: nextEnd,
        prevStart: prevStart,
        getPagedProducts: getPagedProducts,
        getPaginationGroup: getPaginationGroup,
        createPagination: createPagination,
        currentPage: currentPage,
        pagination: pagination,
        pages: pages,
        limit: limit,
        resetPage: resetPage
    };
};


/***/ })

}]);